<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M27 9L9 27" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 9L27 27" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCloseBig',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
